import React, { useState, useEffect, useContext } from "react";
import { Card, Col, Row, CardBody } from "reactstrap";
import SelectDocumentsStep from "./SelectDocumentsStep";
import UploadDocumentsStep from "./UploadDocumentsStep";
import { CourseContext } from "../../course/CourseContext";
import axios from "axios";

const AdminUploadDocumentsForm = ({ stageId, applicant }) => {
  const { descriptors } = useContext(CourseContext);
  const [step, setStep] = useState(1);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [requestedDocuments, setRequestedDocuments] = useState([]);
  const [hasPreconfiguredDocuments, setHasPreconfiguredDocuments] = useState(false);

  useEffect(() => {
    axios.get(`/api/admin_personal_documents/existing_documents?stage_id=${stageId}`)
      .then(response => {
        if (response.status === 200 && response.data.length > 0) {
          setRequestedDocuments(response.data);
          setStep(2);
          setHasPreconfiguredDocuments(true);
        } else {
          setStep(1);
          setHasPreconfiguredDocuments(false);
        }
      })
      .catch(error => {
        setStep(1);
        setHasPreconfiguredDocuments(false);
      });
  }, [stageId]);

  const handleNextStep = (documents) => {
    setSelectedDocuments(documents);
    axios.post(`/api/admin_personal_documents/initialize_requested_documents`, {
      stage_id: stageId,
      applicant_id: applicant.id,
      document_descriptors: documents.map(doc => doc.value)
    }, {
      headers: { "X-CSRF-TOKEN": window.Hupe8.token }
    })
      .then(response => {
        setRequestedDocuments(response.data);
        setStep(2);
      })
      .catch(error => console.error("Error inicializando documentos:", error));
  };

  const handleBack = () => {
      if (!hasPreconfiguredDocuments) {
        if (window.confirm("¿Seguro que quieres eliminar todos los documentos y volver a seleccionar?")) {
          axios.delete(`/api/admin_personal_documents/destroy_all`, {
            data: { stage_id: stageId },
            headers: { "X-CSRF-TOKEN": window.Hupe8.token }
          })
            .then(() => {
              setRequestedDocuments([]);
              setStep(1);
            })
            .catch(error => console.error("Error eliminando documentos:", error));
        }
      }
  };

  return (
    <Row>
      <Col md="12">
        {step === 1 && (
          <SelectDocumentsStep documentDescriptors={descriptors} onNext={handleNextStep} />
        )}
        {step === 2 && (
          <UploadDocumentsStep
            stageId={stageId}
            requestedDocuments={requestedDocuments}
            onBack={handleBack}
            showBackButton={!hasPreconfiguredDocuments}
          />
        )}
      </Col>
    </Row>
  );
};

export default AdminUploadDocumentsForm;
